/**
 * All hardcoded customer-facing email addresses shown in product UI (pricing, billing, mailto).
 * Add new entries here; do not scatter addresses across catalog or plan data.
 */
export const MUGGLE_CUSTOMER_FACING_EMAILS = {
  ENTERPRISE_SALES: "sales@muggle-ai.com",
} as const;
